import React, { useState, useEffect, useContext } from "react";
import logo from "../asset/pngImage/logo.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import Cart from "../page/Cart";
import { useSelector, useDispatch } from "react-redux";
// import { refreshCart } from "../reduxSetup/slices/productsSlice";
import { URL } from "../url/api";
import useCart from "../hooks/useCart";
// import { requestFirebaseNotificationToken } from "../utils/fcm";
// import axioswToken from "../api/axios";
// import { DashboardContext } from "../context/DashboardContext";

export default function Header(props) {
  // console.log('Header renderd');
  // const {dashboardData} = useContext(DashboardContext);
  // console.log(dashboardData);
  const { fetchCart } = useCart();
  // const dispatch = useDispatch();
  
  const navigate = useNavigate();
  const location = useLocation();
  const cookieValue = Cookies.get("user_session");
  const searchParams = new URLSearchParams(location.search);
  const search = searchParams.get("q");
  const [searchTerm, setSearchTerm] = useState("");
  const [bannerData, setBannerData] = useState([]);
  const [dashboard_data, setDashboard_Data] = useState(null);
  const [data, setData] = useState([]);
  const [subCataegories, setSubCataegories] = useState([]);
  const [loading, setLoading] = useState(false);
  const count = useSelector((state) => state.product.data);
  const [navbarCollapsed, setNavbarCollapsed] = useState(true);

  useEffect(()=>{
    const token = Cookies.get("user_session");    
    if(token){
      localStorage.setItem('user_session', token);
      fetchCart();
      // requestFirebaseNotificationToken().then((FCMToken) => {
      //   if(FCMToken){
      //     axioswToken.post(`${URL}/update`, {
      //       FCMToken
      //     });
      //   }
      // })
    }
  }, []);
  useEffect(() => {
    checkLogin();
    return () => {
      checkLogin();
    };
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);

  //     try {
  //       // Make both API calls concurrently
  //       const [dashboardResponse, subCategoriesResponse] = await Promise.all([
  //         fetch(`${URL}/getDashboard`, { method: "GET", redirect: "follow" }),
  //         fetch(`${URL}/getSubCategories`, {
  //           method: "GET",
  //           redirect: "follow",
  //         }),
  //       ]);

  //       // Process the response from the first API call (getDashboard)
  //       const dashboardResult = await dashboardResponse.text();
  //       const dashboardData = JSON.parse(dashboardResult);
  //       const sliderArray = dashboardData.data.sliders.map((slide) => {
  //         return {
  //           image: slide?.image,
  //           redirect_url: slide?.redirect_url, // Ensure this property exists in your response
  //         };
  //       });
  //       setDashboard_Data(dashboardData);
  //       setBannerData(sliderArray);
  //       setData(dashboardData.data.categories);

  //       // Process the response from the second API call (getFeaturedProducts)
  //       const subCategoriesResult = await subCategoriesResponse.text();
  //       const subCategoriesData = JSON.parse(subCategoriesResult);
  //       setSubCataegories(subCategoriesData.data);

  //       setLoading(false);
  //     } catch (error) {
  //       setLoading(false);
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);
  // const premium_item = data.filter((item) => item.name === "New Launch");
  const checkLogin = () => {
    try {
      const session = Cookies.get("user_session");
      if (session !== undefined && session !== null) {
        const token = JSON.parse(session);
      }
    } catch (error) {
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
    }
  };
  const phoneNumber = "9654760719"; // Replace with the actual phone number
  const message = encodeURIComponent("Hi, I am Interested in Bulk Purchase?");

  const sendMessage = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };
  const handleSearch = () => {
    // Navigate to the search results page with the search term as a query parameter
    navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
  };
  return (
    <div>
      <nav
        className="navbar navbar-expand-lg fixed-top"
        style={{ backgroundColor: "#efe9e3" }}
      >
        <div className="container-fluid">
          {/* zaya logo */}
          <Link to={"/"} className="logoheader">
            <img
              src={logo}
              alt={"ZayaDryFruits"}
              loading="lazy"
              style={{ height: "100%", width: "70%" }}
            />
          </Link>
          {/* toogle button in mobile view */}
          <button
            className="btn btn_offcanvas"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasWithBothOptions"
            aria-controls="offcanvasWithBothOptions"
            aria-label="Toggle Navbar"
            title="Toggle Navbar"
            onClick={() => {
              setNavbarCollapsed(!navbarCollapsed);
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {/* search field in mobile view */}
          <div className="searchInput_fild">
            {search ? null : (
              <div className="col-auto my-2 mx-2" id="searchDetails">
                <div className="input-group">
                  <input
                    type="search"
                    placeholder="Search"
                    className="form-control"
                    id="autoSizingInputGroup1"
                    value={searchTerm}
                    onKeyPress={handleKeyPress}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-primary p-2"
                    aria-label="Search"
                    title="Search"
                    onClick={() => {
                      handleSearch();
                      setNavbarCollapsed(true);
                    }}
                  >
                    <i className="fa-solid fa-magnifying-glass"></i>
                  </button>
                </div>
              </div>
            )}
          </div>

          <div
            className={`offcanvas offcanvas-start ${
              navbarCollapsed ? "" : "show"
            }`}
            style={{ width: "75%" }}
            data-bs-scroll="true"
            tabIndex="-1"
            id="offcanvasWithBothOptions"
            aria-labelledby="offcanvasWithBothOptionsLabel"
          >
            <div className="offcanvas-body">
              {/* zaya logo */}
              <a href={"/"} className="logoheader1">
                <img
                  src={logo}
                  alt={"ZayaDryFruits"}
                  loading="lazy"
                  style={{
                    height: "6%",
                    width: "40%",
                    marginLeft: "25%",
                  }}
                />
              </a>
              <hr />
              {/* navbar items */}
              <ul className="navbar-nav mb-2 mb-lg-0 w-50">
                <li className="nav-item text-align-left">
                  <Link
                    className="nav-link"
                    aria-current="page"
                    to="/"
                    onClick={() => setNavbarCollapsed(true)}
                  >
                    {props.title}
                  </Link>
                </li>
                <li className="nav-item text-align-left">
                  <Link
                    className="nav-link"
                    to={'/store'}
                    // to="/shop/1"
                    onClick={() => setNavbarCollapsed(true)}
                  >
                    {props.Shop}
                  </Link>
                </li>
                <li className="nav-item text-align-left">
                  <Link
                    className="nav-link"
                    to={`/Khari-Baoli-Dry-Fruits-Rate-List-Today`}
                    // to="/shop/1"
                    onClick={() => setNavbarCollapsed(true)}
                  >
                    {props.All}
                  </Link>
                </li>
                {/* <li className="nav-item text-align-left">
                  {premium_item.length > 0 &&
                  dashboard_data.data.premium === premium_item[0].name
                    ? (() => {
                        let name = premium_item[0].name;
                        const product = name
                          .replace(/[\s()]+/g, "-")
                          .replace(/-+$/, "");
                        let subCategoryName =
                          premium_item[0]?.subcategory?.[0]?.name;
                        const subCategoryProduct = subCategoryName
                          ? subCategoryName
                              .replace(/[\s()]+/g, "-")
                              .replace(/-+$/, "")
                          : "";

                        return (
                          <Link
                            className="nav-link"
                            to={`/category/${premium_item[0].id}/${product}/${premium_item[0]?.subcategory?.[0]?.id}/${subCategoryProduct}`}
                            onClick={() => {
                              console.log("premium_item", premium_item);
                            }}
                          >
                            Premium Category
                          </Link>
                        );
                      })()
                    : null}
                </li> */}
                <li className="nav-item text-align-left">
                  <button className="btn btn-primary" onClick={sendMessage}>
                    Bulk Enquiry <i className="fa fa-external-link"></i>
                  </button>
                </li>
              </ul>
              {/* search field in web view */}
              <div className="searchInput_fild1 w-50 ms-2">
                {search ? null : (
                  <div className="input-group">
                    {/* <div className="input-group-text">@</div> */}
                    <input
                      type="search"
                      placeholder="Search"
                      className="form-control"
                      id="autoSizingInputGroup"
                      value={searchTerm}
                      onKeyPress={handleKeyPress}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        handleSearch();
                        setNavbarCollapsed(true);
                      }}
                    >
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* loginbutton or profile icon */}
          <div style={{ alignItems: "center", alignSelf: "center" }}>
            {cookieValue == null ? (
              <Link
                className="nav-link "
                to="/login"
                onClick={() => setNavbarCollapsed(true)}
              >
                <button
                  type="button"
                  className="btn btn-primary m-2 registerbutton"
                >
                  login/Register
                </button>
                <div
                  className="text-center loginbutton"
                  style={{ lineHeight: 0.2 }}
                >
                  <i className="fa fa-right-to-bracket my-icon p-0" />
                  <br />
                  <span style={{ fontSize: 12, marginTop: 0 }}>login</span>
                </div>
              </Link>
            ) : (
              <Link
                className="nav-link "
                to="/profile"
                onClick={() => setNavbarCollapsed(true)}
              >
                <i className="fa fa-user-circle my-icon profileicon" />
                <i className="fa fa-user-circle my-icon profileicon1" />
                {/* <span className="profileicon1">Profile</span> */}
              </Link>
            )}
          </div>
          {/* cart icon */}
          <div
            className="cartdiv d-flex"
            style={{
              alignItems: "center",
            }}
          >
            <i
              className="fa-solid fa-bag-shopping my-icon"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasWithBackdrop"
              aria-controls="offcanvasWithBackdrop"
              role="button"
            />
            {count?.length > 0 ? <p className="cart">{count?.length}</p> : null}
          </div>
        </div>
      </nav>
      <Cart />
    </div>
  );
}
